import {Component, OnInit, Input, Output, EventEmitter, HostBinding} from '@angular/core';

@Component({
	selector: "cp-button-widget-custom",
	templateUrl: "./button.widget.custom.component.html",
	styleUrls: ["./button.widget.custom.component.scss"]
})
export class ButtonWidgetCustomComponent implements OnInit {
	@Input() captionToTranslate: string;
	@Input() translationParameters: any[];
  @Input() iconName: string;
  @Input() type: "button" | "submit" = "button";

	@HostBinding("class.disabled") @Input() disabled: boolean;

	@Output() onClick: EventEmitter<void> = new EventEmitter<void>();

	constructor() { }

	ngOnInit() {

	}

	public clickHandler() {
		if (!this.disabled) {
			this.onClick.emit();
		}
	}
}
